import { z } from "zod"

export const DartySessionSchema = z.object({
    affiliateCode: z.string(),
    accessToken: z.string(),
    user: z.object({
        uid: z.string(),
        fullname: z.string(),
    }),
    affiliateQueryParams: z
        .object({
            store: z.object({
                identifier: z.string(),
                name: z.string(),
            }),
            employee: z.object({
                id: z.string(),
            }),
        })
        .optional(),
})
